import { Box, styled } from '@mui/system'

export const DashboardContainer = styled(
  Box,
  {}
)({
  display: 'flex',
  alignItems: 'stretch',
  height: `calc(100vh - 75px)`,
  overflowX: 'hidden'
})

export const LeftSection = styled('div')({
  width: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '24px 24px',
  boxSizing: 'border-box'
})

export const SummaryContainer = styled('div')({
  width: '100%',
  maxWidth: '100%',
  marginRight: 'auto',
  marginLeft: 'auto'
})
